// 버전 체크 React Hook
import { useEffect, useRef, useState } from 'react';
import {
  checkForNewVersion,
  initializeVersion,
  VERSION_CHECK_INTERVAL
} from '../utils/versionCheck';

/**
 * 주기적으로 새 버전을 체크하는 Hook
 * @param {Function} onNewVersion - 새 버전 감지 시 호출되는 콜백
 * @param {Object} options - 옵션
 * @param {boolean} options.enabled - 버전 체크 활성화 여부 (기본: true)
 * @param {number} options.interval - 체크 주기 (밀리초, 기본: 30000)
 */
export function useVersionCheck(onNewVersion, options = {}) {
  const {
    enabled = true,
    interval = VERSION_CHECK_INTERVAL
  } = options;

  const [hasNewVersion, setHasNewVersion] = useState(false);
  const intervalRef = useRef(null);
  const onNewVersionRef = useRef(onNewVersion);

  // 콜백 참조 업데이트
  useEffect(() => {
    onNewVersionRef.current = onNewVersion;
  }, [onNewVersion]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    // 초기 버전 설정
    initializeVersion();

    // 주기적으로 버전 체크
    const startVersionCheck = () => {
      intervalRef.current = setInterval(async () => {
        try {
          const isNewVersion = await checkForNewVersion();
          
          if (isNewVersion && !hasNewVersion) {
            setHasNewVersion(true);
            
            if (onNewVersionRef.current) {
              onNewVersionRef.current();
            }
          }
        } catch (error) {
          console.error('버전 체크 중 오류:', error);
        }
      }, interval);
    };

    // 첫 체크는 5초 후에 시작 (앱 로딩 후)
    const initialTimeout = setTimeout(() => {
      startVersionCheck();
    }, 5000);

    // 클린업
    return () => {
      clearTimeout(initialTimeout);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [enabled, interval, hasNewVersion]);

  return { hasNewVersion };
}

export default useVersionCheck;



